// extracted by mini-css-extract-plugin
export var leftAlign = "_a-2";
export var popper = "_a-0";
export var subtitle = "_a-1";